var _rect, _rect2, _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3Inactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#969696",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_18336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7757 26.5692H14.3378C14.0263 26.5692 13.7737 26.8218 13.7737 27.1333C13.7737 27.4448 14.0263 27.6974 14.3378 27.6974C15.2155 27.6974 15.9296 28.4093 15.9296 29.2843C15.9296 30.1593 15.2155 30.8712 14.3378 30.8712H14.2313C13.35 30.8712 12.633 30.1543 12.633 29.273V11.1282H27.1419V22.4326C27.1419 22.7441 27.3945 22.9967 27.706 22.9967C28.0175 22.9967 28.2701 22.7441 28.2701 22.4326V10.5641C28.2701 10.2526 28.0175 10 27.706 10H12.069C11.7575 10 11.5049 10.2526 11.5049 10.5641V29.273C11.5049 30.8158 12.8146 32.0313 14.3378 31.9994H27.7758C29.2756 31.9994 30.4959 30.7814 30.4959 29.2843C30.4959 27.7872 29.2756 26.5692 27.7757 26.5692ZM27.7757 30.8712H16.5436C17.2216 29.9348 17.2216 28.6339 16.5436 27.6974H27.7757C28.6535 27.6974 29.3676 28.4093 29.3676 29.2843C29.3676 30.1593 28.6535 30.8712 27.7757 30.8712Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2724 15.0108C19.7286 14.7863 19.6368 14.6813 19.6368 14.531C19.6368 14.3569 19.7849 14.257 20.0431 14.257C20.4031 14.257 20.7215 14.4355 21.0234 14.6114L21.3953 13.6316C21.1106 13.455 20.8066 13.3135 20.4723 13.2617V12.5996H19.4822V13.3231C18.8668 13.5117 18.4887 13.9974 18.4887 14.6098C18.4887 15.4107 19.13 15.7696 19.756 16.0146C20.2497 16.2143 20.3177 16.3787 20.3177 16.5265C20.3177 16.7409 20.1247 16.8793 19.8259 16.8793C19.4118 16.8793 19.0563 16.6699 18.7313 16.4362L18.373 17.434C18.6784 17.6789 19.0486 17.8308 19.4361 17.8841V18.5695H20.4329V17.8258C21.0675 17.6293 21.4724 17.1102 21.4724 16.4806C21.4724 15.8018 21.1023 15.3485 20.2724 15.0108Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8543 21.1565H14.9215C14.61 21.1565 14.3574 20.904 14.3574 20.5924C14.3574 20.2808 14.61 20.0283 14.9215 20.0283H24.8542C25.1658 20.0283 25.4183 20.2808 25.4183 20.5924C25.4183 20.904 25.1658 21.1565 24.8543 21.1565Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9438 24.3491H14.9215C14.61 24.3491 14.3574 24.0966 14.3574 23.785C14.3574 23.4735 14.61 23.2209 14.9215 23.2209H22.9438C23.2553 23.2209 23.5079 23.4735 23.5079 23.785C23.5079 24.0966 23.2553 24.3491 22.9438 24.3491Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.706 25.3907C28.0694 25.3907 28.3641 25.096 28.3641 24.7326C28.3641 24.3691 28.0694 24.0745 27.706 24.0745C27.3425 24.0745 27.0479 24.3691 27.0479 24.7326C27.0479 25.096 27.3425 25.3907 27.706 25.3907Z",
    fill: "#969696"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_18336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Inactive);
export default __webpack_public_path__ + "static/media/step3-inactive.36c68755f5b29bd8923b70d6f829cbee.svg";
export { ForwardRef as ReactComponent };